import './polyfills';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import { createBrowserHistory } from 'history';
import * as ReactGA from 'react-ga';

import { createStores } from './app/stores';
import { STORE_ROUTER } from './app/constants/stores';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'sanitize.css';
import './style.css';

// enable MobX strict mode
configure({ enforceActions: 'observed' });

// prepare MobX stores
const history = createBrowserHistory();

// Enable ga only on production & staging
if (
  process.env.REACT_APP_ENV === 'production' ||
  process.env.REACT_APP_ENV === 'staging'
) {
  // initialise ga
  if (process.env.REACT_APP_GA_TRACKING_ID) {
    ReactGA.initialize([{ trackingId: process.env.REACT_APP_GA_TRACKING_ID }]);
  }
}

const rootStore = createStores(history);
const mobxHistory = rootStore[STORE_ROUTER].history;

// render react DOM
ReactDOM.render(
  <Provider {...rootStore}>
    <App
      history={mobxHistory}
      DevTools={
        process.env.REACT_APP_ENV === 'development'
          ? require('mobx-react-devtools').default
          : null
      }
    />
  </Provider>,
  document.getElementById('app') as HTMLElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx